import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './supporting-content-item.component.scss';
var SupportingContentItem = /** @class */ (function (_super) {
    tslib_1.__extends(SupportingContentItem, _super);
    function SupportingContentItem(element) {
        return _super.call(this, element) || this;
    }
    SupportingContentItem.prototype.init = function () { };
    ;
    SupportingContentItem.prototype.bindEvents = function () { };
    ;
    return SupportingContentItem;
}(Base));
export { SupportingContentItem };



//////////////////
// WEBPACK FOOTER
// ./components/supporting-content-item/supporting-content-item.component.ts
// module id = 518
// module chunks = 0